import { GET_COLLECTION_HISTORY_SUCCESS, GET_COLLECTIONS_SUCCESS } from './collections.types';

const initialState = {
  collections: [],
  collectionHistory: [],
};

export const collectionReducer = (state = initialState, action) => {
  switch (action.type) {

    /** Collections */

    case GET_COLLECTIONS_SUCCESS:
      return {
        ...state,
        collections: action.payload,
      };

    case GET_COLLECTION_HISTORY_SUCCESS:
      return {
        ...state,
        collectionHistory: action.payload,
      };

    /** End */

    default:
      return state;
  }
};
